<!-- 树节点 -->
<template>
  <div class="yxt-category-tree-node" :key="data.nodeId" :draggable="showSort" @dragstart.stop="handleDragStart"
    @dragover.stop="handleDragOver" @dragenter.stop="draggingTag = false" @dragleave.stop="draggingTag = false"
    @drop.stop="handleDrop">
    <!-- 当前节点 -->
    <div class="drag-line" v-show="draggingTag && dragDerection === 'up'"></div>
    <div class="yxt-category-tree-node-item" @click="onClick" :class="{
      'is-active': (state.active || data.nodeId === activeId),
      'not-allowed': rootDisabled && !multiple
    }" :style="'padding-left: ' + (20 * index + 8) + 'px'">
      <yxt-svg icon-class="sort" v-if="showSort" class="color-gray-6 sort-svg" style="cursor: grab;" width="16px" height="16px"></yxt-svg>
      <span @click.stop="changeExpanded(!expanded, true)">
        <yxt-svg :class="{
          visible: data.hasChild
        }" :icon-class="expanded ? 'down' : 'common_right'"
          class="expand-svg color-gray-6 hover-primary-6 hover-pointer" width="20px" height="16px"></yxt-svg>
      </span>
      <div class="ml4 mr4" v-if="multiple && !rootDisabled && !(data.depth === 0 && data.hasAllDeptPermission === 0)">
        <yxt-checkbox v-model="state.checked" @change="handleChecked" :disabled="state.disabled"></yxt-checkbox>
      </div>
      <yxt-tooltip class="item" :content="rootTips" placement="top" :disabled="rootType !== 1 || mode !== 2 || data.depth !== 0 || multiple">
        <div class="node-name ml4">
            <component v-if="nodeRender" :is="customComponent(data.nodeName)"/>
            <template v-else>{{ data.nodeName }}</template>
            {{ data.refCnt !== undefined ? `(${data.refCnt})` : '' }}
        </div>
      </yxt-tooltip>
      <yxt-dropdown trigger="hover" custom-elm @command="handleSetting" v-if="showInsert || showModified || showDelete || checkChild || showExport">
        <div class="setting-svg hover-primary-6 hover-pointer color-gray-6">
          <i class="yxt-icon-setting"></i>
        </div>
        <yxt-dropdown-menu slot="dropdown">
          <yxt-dropdown-item command="create" v-if="showInsert">{{ getSettingText('add') }}</yxt-dropdown-item>
          <yxt-dropdown-item command="update" v-if="showModified">{{ getSettingText('modify') }}</yxt-dropdown-item>
          <yxt-dropdown-item command="delete" v-if="showDelete">{{ getSettingText('delete') }}</yxt-dropdown-item>
          <yxt-dropdown-item command="checkChild" v-if="checkChild" :disabled="state.disabled">{{ getSettingText('checkChild') }}</yxt-dropdown-item>
          <yxt-dropdown-item command="export" v-if="showExport">{{ getSettingText('export') }}</yxt-dropdown-item>
        </yxt-dropdown-menu>
      </yxt-dropdown>
    </div>
    <!-- 遍历子节点 -->
    <div v-if="data.hasChild" class="yxt-category-tree-node-child-container" v-show="expanded" >
      <yxt-category-tree-node :limit="limit" :settings="settings" :sort="sort"
        :deleteFunc="deleteFunc" :get-cate-children="getCateChildren" :handle-click="handleClick"
        :handle-check="handleCheck" :showForm="showForm" :selectedId="selectedId" :checkedIds="checkedIds"
        :afterDelete="handleDeleteChild" @dragStarted="handleDragItemStart" @dragEnd="handleDragEnd"
        :pnodeId="data.nodeId"  v-for="item in data.children" :data="item" :index="index + 1" :key="item.nodeId"
        :multiple="multiple" :expandAll="expandAll" :sortable="sortable" :firstModifiable="firstModifiable"
        :modifiable="modifiable" :containChildren="state.checkChild" :rootType="rootType" :searchState="searchState"
        :checkType="checkType" :activeId="activeId" :mode="mode"
        :nodeRender="nodeRender"
        :parentChecked="state.checked" :parentResetCheckChild="resetCheckChild"></yxt-category-tree-node>
    </div>
    <div class="drag-line" v-show="draggingTag && dragDerection === 'down'"></div>
  </div>
</template>

<script>
import Locale from '@utils/mixins/locale';
import EventBus from './eventBus';
import Vue from 'vue'
window.category_tree_tmpDragData = null;
export default {
  mixins: [Locale],
  name: 'yxt-category-tree-node',
  data() {
    return {
      rootTips: '',
      dragData: null,
      // active: false, // 是否选中高亮
      draggingTag: false, // 是否展示拖拽的蓝线
      childActive: false,
      state: {
        active: false,
        checked: false,
        disabled: false,
        checkChild: false,
        nodeId: '',
        nodeName: ''
      },
      dragDerection: '',
      expanded: this.expandAll
    };
  },
  props: {
    activeId: {
      type: String,
      default: '' // 当前激活的节点id 操作树下可用
    },
    parentChecked: {
      type: Boolean,
      default: false
    },
    checkType: {
      type: Number,
      default: 0 // 0: 非部门树 1：选择所属部门，2：选择部门范围
    },
    // 根节点不支持关联数据的配置
    rootType: {
      type: Number,
      default: 1 // 1：开启--不允许关联数据，2：未开启--允许关联数据
    },
    mode: {
      type: Number,
      default: 1 // 1（操作树），2（选择树 )
    },
    containChildren: {
      type: Boolean,
      default: false
    },
    showExport: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {
        return {
          add: {
            text: '新增'
          },
          delete: {
            text: '删除'
          },
          modify: {
            text: '编辑'
          }
        };
      }
    },
    pdragging: {
      type: Boolean | Object | null,
      default: false
    },
    data: {
      type: Object,
      required: true
    },
    pnodeId: {
      type: String,
      default: ''
    },
    selectedId: {
      type: String,
      default: '' // 单选-默认选中的分类nodeId
    },
    checkedIds: {
      type: [Array, String, Number]
    },
    parentResetCheckChild: {
      type: Function
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // 是否展开全部子分类
    expandAll: {
      type: Boolean,
      default: false
    },
    // 是否展开当前分类
    expandedDefault: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Boolean,
      default: true
    },
    firstModifiable: {
      type: Boolean,
      default: true
    },
    modifiable: {
      type: Object,
      default: () => {
        return {
          add: true,
          delete: true,
          modify: true
        };
      }
    },
    handleClick: {
      type: Function
    },
    handleCheck: {
      type: Function
    },
    showForm: {
      type: Function
    },
    afterDelete: {
      type: Function
    },
    getCateChildren: {
      type: Function
    },
    sort: {
      type: Function
    },
    deleteFunc: {
      type: Function
    },
    // 当前node的层级-前端界面展示的层级，不是数据库中的层级
    index: {
      type: Number
    },
    limit: {
      type: Number
    },
    searchState: {
      type: Boolean,
      default: false
    },
    nodeRender:{
      type: Function
    }
  },
  watch: {
    expandAll(v) {
      if (v && this.data.hasChild && this.data.children.length) {
        this.changeExpanded(true);
      } else {
        this.changeExpanded(false);
      }
    },
    checkedIds() {
      this.init();
    }
  },
  computed: {
    dragging() {
      return this.dragData;
    },
    // 根节点是否禁用
    rootDisabled() {
      // return this.mode === 2 && this.data.depth === 0 && this.rootType === 1;
      return this.mode === 2 && this.data.depth === 0 && (this.rootType === 1 || this.data.hasAllDeptPermission === 0);
    },
    // 是否展示新增按钮
    showInsert() {
      if (!this.data.depth) {
        return this.firstModifiable;
      } else if (this.data.depth === 20) {
        return false;
      } else if (this.data.children && this.data.children.length > 999) {
        return false;
      } else if (this.modifiable.add === undefined || this.modifiable.add === null) {
        return false;
      } else {
        return !!this.modifiable.add;
      }
    },
    // 是否展示编辑按钮
    showModified() {
      if (!this.data.depth) {
        return false;
      } else if (this.data.depth === 1) {
        return this.firstModifiable;
      } else if (this.modifiable.modify === undefined || this.modifiable.modify === null) {
        return false;
      } else {
        return !!this.modifiable.modify;
      }
    },
    // 是否展示删除按钮
    showDelete() {
      if (!this.data.depth) return false;
      if (this.data.depth === 1) return this.firstModifiable;
      else if (
        this.modifiable.delete === undefined ||
        this.modifiable.delete === null
      ) {
        return false;
      } else return !!this.modifiable.delete;
    },
    // 是否展示全选子节点
    showCheckAll() {
      return this.multiple && this.data.depth > 0;
    },
    // 是否展示排序按钮
    showSort() {
      return this.sortable && this.data.depth > 0;
    },
    checkChild() {
      if (!this.data.depth) return false;
      return this.mode === 2 && this.checkType !== 0 && this.multiple;
    }
  },
  created() {
    this.rootTips = this.t('pc_common_cate_root_tips');
    this.init();
    EventBus.$on('refresh-' + this.data.nodeId, this.refresh);
  },
  beforeDestroy() {
    this.expanded = false;
    EventBus.$off('refresh-' + this.data.nodeId, this.refresh);
  },
  methods: {
    customComponent(value){
      return Vue.extend({
        functional: true,
        render: (h, context) => this.nodeRender(value),
      })
    },
    getSettingText(key) {
      const settingMapKey = {
        add: 'pc_biz_cate_add',
        delete: 'pc_common_cate_delete',
        modify: 'pc_common_cate_edit',
        checkChild: 'pc_biz_cate_checkAllChild',
        export: 'pc_biz_cate_export'
      };
      return (this.settings[key] && this.settings[key].text) || this.t(settingMapKey[key]);
    },
    // 更新子节点
    refresh({ isAdd, data, nodeId }) {
      if (isAdd) {
        data.depth = (this.data.depth || 0) + 1;
        this.data.hasChild = true;
        if (!this.data.children || !this.data.children.length) {
          this.data.children = []
        }
        this.data.children.push(data);
        this.changeExpanded(true);
      } else {
        if (this.data.hasChild && this.data.children.length) {
          const index = this.data.children.findIndex(
            item => item.nodeId === nodeId
          );
          if (index > -1) this.data.children.splice(index, 1);
        }
        this.data.hasChild = this.data.children.length > 0;
        if (!this.data.hasChild) {
          this.expanded = false;
        }
      }
    },
    init() {
      this.state.nodeId = this.data.nodeId;
      this.state.nodeName = this.data.nodeName;
      this.expanded = this.expanded || this.expandedDefault;
      if (Array.isArray(this.checkedIds)) {
        this.state.checked = this.checkedIds.includes(this.data.nodeId);
      } else {
        this.state.checked = this.checkedIds === this.data.nodeId;
        this.state.active = this.state.checked;
      }
      if (!this.state.checked && this.parentChecked && this.containChildren) {
        this.state.checked = true;
        this.handleChecked(true);
      }
      if (!this.state.checked && this.parentChecked && this.checkType === 2) {
        this.state.checked = true;
      }
      this.state.disabled = this.parentChecked && this.checkType === 2;
      if (this.expandedDefault || this.expanded || this.searchState) {
        this.changeExpanded(true);
      } else {
        this.changeExpanded(false);
      }
    },
    onClick(e) {
      if (e && e.target) {
        // 点击展开按钮或者设置按钮停止事件冒泡
        if (
          this.rootDisabled ||
          e.target.classList.contains('expand-svg') ||
          e.target.classList.contains('yxt-icon-setting')
        ) {
          e.preventDefault();
          return;
        }
      }
      if (this.multiple) return;
      try {
        this.handleClick(this.state, JSON.parse(JSON.stringify(this.data)));
      } catch (e) {
        this.handleClick(this.state);
      }
    },
    // 勾选
    handleChecked(v) {
      if (this.limit !== 0 && this.limit <= this.checkedIds.length && v && this.limit && this.checkType !== 2) {
        this.state.checkChild = false;
        this.state.checked = false;
        this.$message.warning(this.t('pc_biz_cate_max_limit1') + this.limit + this.t('pc_biz_cate_max_limit3'));
        return;
      }
      if (!v) {
        this.state.checkChild = false;
        this.parentResetCheckChild(false);
      }
      v && (this.checkType === 2) && this.removeChildData(this.data.children)
      this.handleCheck(v, this.state.nodeId, this.state.nodeName);
    },
    removeChildData(list) {
      if (!this.multiple) return
      list.forEach(item => {
        const index = this.checkedIds.indexOf(item.nodeId)
        if(index > -1) {
          // this.checkedIds.splice(index,1)
          this.handleCheck(false, item.nodeId)
        }
        if(item.children && item.children.length) this.removeChildData(item.children)
      });
    },
    resetCheckChild(isChecked, state) {
      if (isChecked) {
        this.state.checkChild = true;
        this.handleCheck(true, state.nodeId, state.nodeName, this.data.children);
      } else {
        this.state.checkChild = false;
      }
    },
    changeExpanded(v, isClickEvent = false) {
      if (!this.data.hasChild) return;
      if (!v || this.data.children.length || isClickEvent) {
        this.expanded = v;
      }
      if (v && isClickEvent) {
        return this.getCateChildren(this.data.nodeId, (treeList) => {
          const { node } = treeList || {};
          this.data.children = node.children;
        });
      }
      if (v && !this.expandAll && !this.searchState && (!this.data.children || !this.data.children.length)) {
        this.getCateChildren(this.data.nodeId, (treeList) => {
          const { node } = treeList || {};
          this.data.children = node.children;
        });
      }
    },
    // 子节点拖拽后
    handleDragItemStart(data) {
      this.dragData = data;
    },
    // 开始拖拽
    handleDragStart(e) {
      this.dragDerection = '';
      window.category_tree_tmpDragData = {
        nodeId: this.data.nodeId,
        pnodeId: this.pnodeId,
        y1: e.clientY
      };
      return;
    },
    handleDragOver(e) {
      // 同一个父节点下的子节点允许拖动,展示标识线条
      // 通过相对竖直位移判断当前的移动方向，来判断移动到当前节点的上面或下面
      if (!window.category_tree_tmpDragData || !window.category_tree_tmpDragData.nodeId) return;
      if (this.pnodeId !== window.category_tree_tmpDragData.pnodeId || !this.pnodeId) {
        this.dragDerection = '';
        this.draggingTag = false;
        e.preventDefault();
        return;
      }
      const y2 = e.clientY;
      this.dragDerection = y2 > window.category_tree_tmpDragData.y1 ? 'down' : 'up';
      this.draggingTag = true;
      e.preventDefault();
    },
    // 拖拽结束
    handleDragEnd(e, nodeId, activeData) {
      try {
        if (activeData.pnodeId !== window.category_tree_tmpDragData.pnodeId || !activeData.pnodeId) {
          return this.$message.warning('只允许同级移动');
        }
        e.preventDefault();
        const data = window.category_tree_tmpDragData;
        const y2 = e.clientY;
        this.dragDerection = y2 > data.y1 ? 'down' : 'up';
        const parentList = this.data.children;
        // if (data.nodeId === nodeId) return;
        // 位置未发生变化则不处理
        let prevNodeId, nextNodeId;
        const fromIndex = parentList.findIndex(
          item => item.nodeId === data.nodeId
        );
        const toIndex = parentList.findIndex(
          item => item.nodeId === nodeId
        );

        // 上移
        if (this.dragDerection === 'up') {
          prevNodeId = parentList[toIndex - 1]
            ? parentList[toIndex - 1].nodeId
            : '';
          nextNodeId = nodeId;
        } else if (this.dragDerection === 'down') {
          // 下移
          prevNodeId = nodeId;
          nextNodeId = parentList[toIndex + 1]
            ? parentList[toIndex + 1].nodeId
            : '';
        }
        if (!this.dragDerection || toIndex === fromIndex) {
          window.category_tree_tmpDragData = null;
          return;
        }
        this.sort({
          nodeId: data.nodeId,
          prevNodeId,
          nextNodeId
        }, (success) => {
          if (success) {
            const item = parentList.splice(fromIndex, 1)[0];
            parentList.splice(toIndex, 0, item);
          }
        });
        window.category_tree_tmpDragData = null;
      } catch (e) {
        console.log(e);
      }
    },
    // 释放修改数据
    // 被拖拽的数据 data, 释放的数据： this.data
    async handleDrop(e) {
      this.dragDerection = '';
      this.draggingTag = false;
      this.$emit('dragEnd', e, this.data.nodeId, {...this.data, pnodeId: this.pnodeId });
    },
    // 设置
    handleSetting(type) {
      if (type === 'delete') {
        this.deleteFunc(this.data.nodeId, (success) => {
          if (success) {
            this.afterDelete(this.data.nodeId);
          }
        });
      } else if (type === 'checkChild') {
        this.parentResetCheckChild(true, this.state);
        // if (this.checkType === 1) {
        //   this.state.checkChild = true;
        //   this.handleChecked(true, this.data.children);
        // } else {
        //   this.handleChecked(true);
        // }
      } else {
        this.showForm({
          nodeId: this.data.nodeId,
          nodeName: this.data.nodeName,
          type: type,
          callback: this.callback
        });
      }
    },
    getNodeName(isEdit, {nodeId, pnodeId, name}) {
      const defaultNodeName = name;
      // 编辑下名字相同无需再去更行名字
      if(isEdit && this.data.nodeName === defaultNodeName) return defaultNodeName;
      try {
        return new Promise((resolve) => {
          this.getCateChildren(pnodeId, (treeList) => {
            const { node } = treeList || {};
            const targetNode = node.children.find(item => item.nodeId === nodeId) || {};
            resolve(targetNode.nodeName || defaultNodeName);
          });
        })
      } catch(e) {}
      return defaultNodeName;
    },
    async callback(res) {
      // 获取正确的name,方案不太好
      res.name = await this.getNodeName(res.nodeId === this.data.nodeId, res);
      if (res.nodeId === this.data.nodeId) {
        // 编辑
        this.data.nodeName = res.name;
        // 所属分类发生变化，则需要更新原父分类和新父分类的子节点
        if (this.pnodeId !== res.pnodeId) {
          EventBus.$emit('refresh-' + this.pnodeId, {
            isAdd: false,
            nodeId: this.data.nodeId
          });
          EventBus.$emit('refresh-' + res.pnodeId, {
            isAdd: true,
            data: this.data
          });
        }
      } else {
        // 新增
        EventBus.$emit('refresh-' + res.pnodeId, {
          isAdd: true,
          data: {
            nodeId: res.nodeId,
            nodeName: res.name || res.nodeName,
            hasChild: false,
            children: []
          }
        });
      }
    },
    handleDeleteChild(nodeId) {
      const index = this.data.children.findIndex(
        item => item.nodeId === nodeId
      );
      this.data.children.splice(index, 1);
      if (!this.data.children.length) {
        this.data.hasChild = false;
        this.expanded = false;
      }
    }
  }
};
</script>
